import { NavigateBackLink, QSetReviewStatusTag } from '@exam-management/components';
import { type Path, useParams } from '@exam-management/router';
import { PageHeader, Text } from '@shared/components';
import { formatDateTime } from '@shared/utils';
import { matchPath, useLocation } from 'react-router-dom';

import { useQSetReviewSubtask } from '../../providers';

export default function QSetReviewSubtaskExamDetailsPageHeader() {
  const location = useLocation();
  const matchedTaskManagement = matchPath(
    '/task-management/qset-review/:taskId/*',
    location.pathname,
  );

  const { subtaskDetails } = useQSetReviewSubtask();
  const paramPath = matchedTaskManagement
    ? '/task-management/qset-review/:taskId/subtask/:subTaskId/task-details/exam-details'
    : '/my-task/qset-review/:taskId/subtask/:subTaskId/task-details/exam-details';
  const { taskId, subTaskId } = useParams(paramPath);

  const path = location.state?.from === 'review-result' ? 'review-result' : 'task-details';

  return (
    <PageHeader
      title={subtaskDetails.name}
      linkAdornment={
        <NavigateBackLink
          to={
            matchedTaskManagement
              ? (`/task-management/qset-review/${taskId}/subtask/${subTaskId}/${path}` as Path)
              : (`/my-task/qset-review/${taskId}/subtask/${subTaskId}/${path}` as Path)
          }
          params={{
            taskId: taskId ?? '',
            subTaskId: subTaskId ?? '',
          }}
          replace
        />
      }
      endAdornment={<QSetReviewStatusTag status={subtaskDetails.currentWorkflowStep.code} />}
      subtitleSection={
        <>
          <Text variant='body2'>Task ID: {subtaskDetails.code}</Text>
          <Text variant='body2'>Last Modified: {formatDateTime(subtaskDetails.updatedAt)}</Text>
        </>
      }
    />
  );
}
